import React from "react"
import { graphql } from "gatsby"

import PropTypes from "prop-types"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import Content from "../components/Content"
import Subcontent from '../components/Content/Subcontent'
import Title from "../components/Content/Title"

const PostPage = ({ data }) => {
  const postdata = data.wordpressPost
  return (
    <Layout>
      <Seo title={`${postdata.title} - Salud, ciencia y tecnología para deportistas - Especiales La Tercera - Presentado por Alemana Sport`} keywords={[`clínica alemana`, `deporte`, `deportistas`, `clínica alemana sport`]} description={postdata.excerpt} shareurl={postdata.featured_media.localFile.childImageSharp.fixed.src}  />
      <Subcontent video={postdata.acf.video_featured} {...postdata} />
      <Title {...postdata} titulo={postdata.acf.titulo} subtitulo={postdata.acf.subtitulo} />
      <Content {...postdata} ></Content>
    </Layout>
  )
}

PostPage.propTypes = {
  data: PropTypes.object.isRequired,
  edges: PropTypes.array,
}

export const pageQuery = graphql`
  query($id: String!) {
    wordpressPost(
      id: {
        eq: $id
      }
    ) {
      id
      slug
      title
      excerpt
      raw
      acf{
        titulo
        subtitulo
        video_featured
      }
      featured_media{
        localFile {
          childImageSharp {
            fixed(
              # maxWidth: 1200,
              width: 1200,
              quality: 90,
              # duotone: {
              #   highlight: "#FF3C00"
              #   shadow: "#192550"
              # }
            ){
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
  }
`

export default PostPage
